import React from 'react';
import Reflux from 'reflux';
import { Row, Col, ButtonInput, Button, Panel } from 'bootstrap';
import ModalActions from 'flux/actions/ModalActions';
import UIRegions from 'shared/constants/UIRegions';
import CuesheetStore from 'shared/flux/stores/cuesheet/CuesheetStore';
import ExportFormStore from 'flux/stores/ExportFormStore';
import ExportFormActions from 'flux/actions/ExportFormActions';
import FormMixin from 'shared/components/form/mixin.jsx';
import { FileTypes } from 'shared/constants/Export';
import { DisplayTypes } from 'shared/constants/FlowConstants';
import DownloadHelper from 'shared/lib/downloadHelper';
import classnames from 'classnames';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import Tile from 'main/components/misc/tile';
import { ToggleSwitch } from '@shoflo-rundown/polymer.legacy';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import FlipMove from 'react-flip-move';
import TeamViewStore from 'flux/stores/TeamViewStore';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

const { csv, xls } = FileTypes;
const typeLookup = {
  [xls]: 'XLS',
  [csv]: 'CSV',
};

const StepOnePanel = 1;
const StepTwoPanel = 2;
const StepThreePanel = 3;

export default React.createClass({
  displayName: 'ExportForm',

  mixins: [
    Reflux.connect(ExportFormStore, 'formState'),
    Reflux.connectFilter(CuesheetStore, 'show', (st) => st.get('show')),
    Reflux.connect(TeamViewStore, 'teamState'),
    FormMixin,
  ],

  contextTypes: {
    user: React.PropTypes.object,
    router: React.PropTypes.object.isRequired,
  },

  getInitialState() {
    return { activePanel: 1 };
  },

  render() {
    const state = this.state.formState;
    const activePanel = this.state.activePanel;

    return (
      <div className="export-form">
        <Row>
          <Col
            className="generic-accordion export-form-accordion-wrapper"
            md={24}
          >
            <TypePanel
              success={activePanel > StepOnePanel}
              expanded={activePanel === StepOnePanel}
              btnText="Next"
              hasBtn={state.get('type')}
              onBtnClick={() => this._handlePanelClick(StepTwoPanel)}
              onHeaderClick={() => this._handlePanelClick(StepOnePanel)}
              activeType={state.get('type')}
              onTypeChange={(type) =>
                this.updateField(
                  'formState',
                  'type',
                  type,
                  ExportFormActions.updateField,
                )
              }
            />
            <ColumnPanel
              success={activePanel > StepTwoPanel}
              expanded={activePanel === StepTwoPanel}
              btnText="Done"
              hasBtn
              onBtnClick={() => this._handlePanelClick(StepThreePanel)}
              onHeaderClick={() => this._handlePanelClick(StepTwoPanel)}
              titleRowsEnabled={state.get('titleRowsEnabled')}
              privateNotesPopulated={state.get('privateNotesPopulated')}
              columnOrder={state.get('columnOrder')}
              disabledColumnOrder={state.get('disabledColumnOrder')}
              columns={state.get('columns')}
              show={this.state.show}
            />
          </Col>
        </Row>
        {this._getReadyMessageNode()}
        <Row>{this._getExportBtn()}</Row>
      </div>
    );
  },

  _handlePanelClick(activePanel) {
    this.setState({ activePanel });
  },

  _getReadyMessageNode() {
    const state = this.state.formState;
    const type = state.get('type');
    const activePanel = this.state.activePanel;

    if (!type) return null;
    if ((type === csv || type === xls) && activePanel <= 2) return null;

    return (
      <Row className="export-form-ready-msg">
        <Col md={24}>
          <p className="export-form-ready-msg-primary">
            Nice, your {typeLookup[type]} is ready!
          </p>
        </Col>
        <Col md={24}>
          <p className="export-form-ready-msg-secondary">
            Press Export {typeLookup[type]} to download it, or edit your
            settings above.
          </p>
        </Col>
      </Row>
    );
  },

  _getExportBtn() {
    const state = this.state.formState;
    const type = state.get('type');
    const activePanel = this.state.activePanel;

    if ((type === csv || type === xls) && activePanel <= 2) return null;
    if (!type) return null;

    const typeTitle = type ? typeLookup[type] : '';

    return (
      <Col className="export-form-btn-wrapper" md={24}>
        <ButtonInput
          disabled={false}
          className="btn-export-modal"
          value={`Export ${typeTitle}`}
          bsSize="large"
          bsStyle="primary"
          onClick={this._submit}
          block
        />
      </Col>
    );
  },

  _submit() {
    const params = this.context.router.state.params;
    const state = this.state.formState;
    let teamLogo = this.state.teamState.get('photo');

    if (!teamLogo) teamLogo = 'noPhoto';

    const query = {
      orientation: state.get('orientation'),
      layoutSize: state.get('layoutSize'),
      size: state.get('size'),
      teamLogo: teamLogo,
      privateNotesPopulated: state.get('privateNotesPopulated'),
      titleRowsEnabled: state.get('titleRowsEnabled'),
    };

    state.get('columnOrder').map((columnId, i) => {
      if (!state.getIn(['columns', columnId, 'enabled'])) return;
      query[`columnOrder[${i}]`] = columnId;
    });

    query.cssZoom = true;

    if (state.get('type') === FileTypes.csv) {
      DownloadHelper.downloadCustomCSV(params, query);
    } else if (state.get('type') === FileTypes.xls) {
      DownloadHelper.downloadCustomXLS(params, query);
    }

    ModalActions.hide(UIRegions.ExportForm);
  },
});

class TypePanel extends React.Component {
  render() {
    const {
      collapsible,
      expanded,
      success,
      btnText,
      hasBtn,
      onBtnClick,
      onHeaderClick,
    } = this.props;

    return (
      <PanelStateless
        expanded={expanded}
        title="Choose your export type"
        number={1}
        success={success}
        collapsible={collapsible}
        btnText={btnText}
        hasBtn={expanded && hasBtn}
        onBtnClick={onBtnClick}
        onHeaderClick={onHeaderClick}
      >
        <Row className="tiles-wrapper tiles-wrapper-export-form">
          {this._getTileNode('Export to XLS', FileTypes.xls, 'file-excel-o')}
          {this._getTileNode('Export to CSV', FileTypes.csv, 'file-text-o')}
        </Row>
      </PanelStateless>
    );
  }

  _getTileNode(title, type, icon) {
    const { activeType, onTypeChange } = this.props;

    return (
      <Col md={12}>
        <Row>
          <Tile
            active={activeType === type}
            icon={icon}
            title={title}
            classes={[`tile-${type}`]}
            handleClick={() => onTypeChange(type)}
          />
        </Row>
      </Col>
    );
  }
}

class ColumnPanel extends React.Component {
  render() {
    const {
      collapsible,
      expanded,
      success,
      btnText,
      hasBtn,
      onBtnClick,
      titleRowsEnabled,
      onHeaderClick,
    } = this.props;

    let enabledTitleRowNode = null;
    let disabledTitleRowNode = null;

    if (titleRowsEnabled) {
      enabledTitleRowNode = this._getTitleRowColumn();
    } else {
      disabledTitleRowNode = this._getTitleRowColumn();
    }

    return (
      <PanelStateless
        btnText={btnText}
        hasBtn={expanded && hasBtn}
        onBtnClick={onBtnClick}
        onHeaderClick={onHeaderClick}
        expanded={expanded}
        success={success}
        title="Set your column visibility and order"
        number={2}
        collapsible={collapsible}
        classes="export-form-columns"
      >
        <div className="export-form-columns-description">
          Set your column visibility and order
        </div>
        <div className="export-form-columns-header">
          <div className="export-form-columns-header-name">Column</div>
          <div className="export-form-columns-header-order">
            Show in export?
          </div>
          <div className="export-form-columns-header-switch">
            Column Position
          </div>
        </div>
        <div className="export-form-columns-list">
          {enabledTitleRowNode}
          {this._getColumns()}
          {this._getDisabledColumns()}
          {disabledTitleRowNode}
        </div>
      </PanelStateless>
    );
  }

  _getTitleRowColumn() {
    const { titleRowsEnabled, show, columns } = this.props;

    if (
      !show.get('displayType') ||
      show.get('displayType') === DisplayTypes.show
    )
      return null;

    return show.get('displayItemTitles') === false ||
      !columns.getIn([EditableCellTypes.ItemTitle, 'enabled']) ? (
      <div>
        <div
          className="export-form-column export-form-column-title-row clearfix"
          key="title-rows"
        >
          <div className="export-form-column-title">Title Rows</div>
          <div className="export-form-column-order"></div>
          {this._getColumnHideToggle(
            'titleRows',
            titleRowsEnabled,
            ExportFormActions.toggleTitleRows,
          )}
        </div>
      </div>
    ) : null;
  }

  _getColumns() {
    const { columns, columnOrder } = this.props;
    return columnOrder.map((columnId) =>
      this._getColumnNode(columns.get(columnId), false),
    );
  }

  _getDisabledColumns() {
    const { columns, disabledColumnOrder } = this.props;
    return disabledColumnOrder.map((columnId) =>
      this._getColumnNode(columns.get(columnId), true),
    );
  }

  _getColumnNode(column, hideReOrder) {
    return (
      <FlipMove enterAnimation="fade" leaveAnimation="fade" duration={550}>
        <div
          key={column.get('_id')}
          className={classnames('export-form-column clearfix', {
            'export-form-column-disabled': !column.get('enabled'),
          })}
        >
          <div className="export-form-column-title">{column.get('title')}</div>
          {hideReOrder ? null : this._getColumnOrderNode(column)}
          {this._getColumnHideToggle(
            column.get('_id'),
            column.get('enabled'),
            ExportFormActions.toggleColumn,
          )}
        </div>
      </FlipMove>
    );
  }

  _getColumnOrderNode(column) {
    return (
      <div className="export-form-column-order">
        <Icon
          name="arrow-circle-o-down"
          onClick={(e) => {
            e.stopPropagation();
            ExportFormActions.moveColumnDown(column.get('_id'));
          }}
        />
        <Icon
          name="arrow-circle-o-up"
          onClick={(e) => {
            e.stopPropagation();
            ExportFormActions.moveColumnUp(column.get('_id'));
          }}
        />
      </div>
    );
  }

  _getColumnHideToggle(columnId, enabled, handler) {
    let privateNotesPopulationNode =
      columnId === EditableCellTypes.ItemNote && enabled
        ? this._getTogglePrivateNotesPopulation()
        : null;

    return (
      <div className="export-form-column-switch">
        <ToggleSwitch on={enabled} onClick={() => handler(columnId)} />
        <div>{privateNotesPopulationNode}</div>
      </div>
    );
  }

  _getTogglePrivateNotesPopulation() {
    let { privateNotesPopulated } = this.props;

    return (
      <div className="export-form-skip-empty-hero">
        <div className="export-form-skip-empty-hero-text">
          Include contents?
        </div>
        <div>
          <span className="hero-input-wrapper export-form-skip-empty-hero-yes">
            <input
              type="radio"
              checked={privateNotesPopulated}
              onClick={() => {
                ExportFormActions.updateField(
                  'privateNotesPopulated',
                  !privateNotesPopulated,
                );
              }}
            />
            &nbsp; Yes
          </span>
          <span className="hero-input-wrapper export-form-skip-empty-hero-no">
            <input
              type="radio"
              checked={!privateNotesPopulated}
              onClick={() => {
                ExportFormActions.updateField(
                  'privateNotesPopulated',
                  !privateNotesPopulated,
                );
              }}
            />
            &nbsp; No
          </span>
        </div>
      </div>
    );
  }
}

const PanelHeader = ({
  number,
  title,
  success, // eslint-disable-line no-unused-vars
  hasBtn,
  onClick,
  onHeaderClick,
  btnText,
}) => {
  let btnNode = null;

  if (hasBtn)
    btnNode = (
      <span className="generic-accordion-panel-header-btn">
        <Button onClick={onClick}>{btnText}</Button>
      </span>
    );

  return (
    <div>
      {btnNode}
      <div
        onClick={onHeaderClick}
        className={classnames('generic-accordion-panel-header')}
      >
        <span className="generic-accordion-panel-header-number">{number}</span>
        <span className="generic-accordion-panel-header-title">{title}</span>
        <Icon
          className="generic-accordion-panel-header-success"
          name="check-circle"
        />
      </div>
    </div>
  );
};

const PanelStateless = ({
  expanded,
  collapsible,
  number,
  title,
  success,
  children,
  classes,
  btnText,
  hasBtn,
  onBtnClick,
  onHeaderClick,
}) => {
  const panelHeaderNode = (
    <PanelHeader
      number={number}
      title={title}
      success={success}
      onClick={onBtnClick}
      onHeaderClick={onHeaderClick}
      hasBtn={hasBtn}
      btnText={btnText}
    />
  );

  return (
    <Panel
      collapsible={collapsible}
      expanded={expanded}
      className={classnames(
        'generic-accordion-panel',
        'export-form-accordion-panel',
        { 'generic-accordian-panel-body-hidden': !expanded },
        { active: expanded, success: success },
        classes,
      )}
      header={panelHeaderNode}
    >
      {children}
    </Panel>
  );
};
